document.querySelectorAll('.continue-shopping').forEach(function (link) {
  link.addEventListener('click', function (e) {
    const productCardInternalReferrer = sessionStorage.getItem('productCardInternalReferrer') === 'true';
    if (productCardInternalReferrer && window.history.length > 2) {
      e.preventDefault();
      history.go(-2);
    }
  });
});